import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";
import { apiCaller } from "../functions";

export function useDiscountsApi() {
    const callApi = useApiCall();

    return {
        searchDiscount: apiCaller(callApi, SAGA_ACTIONS.DISCOUNTS.SEARCH_DISCOUNT),
        addUpdateDiscount: apiCaller(callApi, SAGA_ACTIONS.DISCOUNTS.ADD_UPDATE_DISCOUNT),
        deleteDiscount: apiCaller(callApi, SAGA_ACTIONS.DISCOUNTS.DELETE_DISCOUNT)        
    };
}
